import { HttpInterceptorFn } from '@angular/common/http';
import { Provider } from '@angular/core';

/**
 * Stands in for `modal-preview.providers.ts` in builds where the harness is
 * disabled, so none of its code reaches the bundle. See that file.
 */
export function modalPreviewAuthProviders(): Provider[] {
  return [];
}

export const modalPreviewStubInterceptorFn: HttpInterceptorFn = (
  request,
  next
) => next(request);
